package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import migrations.TemplatePageSectionTable

public class TemplatePageSectionTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getTemplatePageSectionsByPageId(pageId: String, mapper: (
    id: String,
    pageId: String,
    title: String,
    orderPosition: Long,
  ) -> T): Query<T> = GetTemplatePageSectionsByPageIdQuery(pageId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun getTemplatePageSectionsByPageId(pageId: String): Query<TemplatePageSectionTable> = getTemplatePageSectionsByPageId(pageId, ::TemplatePageSectionTable)

  public fun <T : Any> getTemplatePageSectionById(id: String, mapper: (
    id: String,
    pageId: String,
    title: String,
    orderPosition: Long,
  ) -> T): Query<T> = GetTemplatePageSectionByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun getTemplatePageSectionById(id: String): Query<TemplatePageSectionTable> = getTemplatePageSectionById(id, ::TemplatePageSectionTable)

  public fun getTemplatePageSectionCountByPageId(pageId: String): Query<Long> = GetTemplatePageSectionCountByPageIdQuery(pageId) { cursor ->
    cursor.getLong(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertTemplatePageSection(
    id: String,
    pageId: String,
    title: String,
    orderPosition: Long,
  ): QueryResult<Long> {
    val result = driver.execute(448_309_855, """
        |INSERT INTO TemplatePageSectionTable(id, pageId, title, orderPosition)
        |VALUES (?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   pageId=excluded.pageId,
        |   title=excluded.title,
        |   orderPosition=excluded.orderPosition
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, pageId)
          bindString(parameterIndex++, title)
          bindLong(parameterIndex++, orderPosition)
        }
    notifyQueries(448_309_855) { emit ->
      emit("TemplatePageSectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceTemplatePageSection(
    id: String,
    pageId: String,
    title: String,
    orderPosition: Long,
  ): QueryResult<Long> {
    val result = driver.execute(-2_076_446_235, """
        |INSERT OR REPLACE INTO TemplatePageSectionTable(id, pageId, title, orderPosition)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, pageId)
          bindString(parameterIndex++, title)
          bindLong(parameterIndex++, orderPosition)
        }
    notifyQueries(-2_076_446_235) { emit ->
      emit("TemplatePageSectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteTemplatePageSectionsByPageId(pageId: String): QueryResult<Long> {
    val result = driver.execute(276_084_039, """DELETE FROM TemplatePageSectionTable WHERE pageId = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, pageId)
        }
    notifyQueries(276_084_039) { emit ->
      emit("TemplatePageSectionTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteTemplatePageSectionById(id: String): QueryResult<Long> {
    val result = driver.execute(-858_308_705, """DELETE FROM TemplatePageSectionTable WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }
    notifyQueries(-858_308_705) { emit ->
      emit("TemplatePageSectionTable")
    }
    return result
  }

  private inner class GetTemplatePageSectionsByPageIdQuery<out T : Any>(
    public val pageId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("TemplatePageSectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("TemplatePageSectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_965_541_718, """SELECT TemplatePageSectionTable.id, TemplatePageSectionTable.pageId, TemplatePageSectionTable.title, TemplatePageSectionTable.orderPosition FROM TemplatePageSectionTable WHERE pageId = ? ORDER BY orderPosition ASC""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, pageId)
    }

    override fun toString(): String = "TemplatePageSectionTable.sq:getTemplatePageSectionsByPageId"
  }

  private inner class GetTemplatePageSectionByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("TemplatePageSectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("TemplatePageSectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(613_100_636, """SELECT TemplatePageSectionTable.id, TemplatePageSectionTable.pageId, TemplatePageSectionTable.title, TemplatePageSectionTable.orderPosition FROM TemplatePageSectionTable WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, id)
    }

    override fun toString(): String = "TemplatePageSectionTable.sq:getTemplatePageSectionById"
  }

  private inner class GetTemplatePageSectionCountByPageIdQuery<out T : Any>(
    public val pageId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("TemplatePageSectionTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("TemplatePageSectionTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(2_069_332_006, """SELECT COUNT(*) FROM TemplatePageSectionTable WHERE pageId = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, pageId)
    }

    override fun toString(): String = "TemplatePageSectionTable.sq:getTemplatePageSectionCountByPageId"
  }
}
